import { RouteError } from '@/components/route-error'
import { createFileRoute } from '@tanstack/react-router'
import { RoutePending } from '@/components/route-pending'

import { TemplatesPage } from '@/features/devices/templates-page'

export const Route = createFileRoute('/_dashboard/devices/templates/')({
  pendingComponent: RoutePending,
  errorComponent: RouteError,
  component: TemplatesIndexPage,
})

function TemplatesIndexPage() {
  return <TemplatesPage selectedId={undefined} />
}
